module.exports = __webpack_public_path__ + "media/images/client-20-1f9cdeadc6a365404e92e4d939854b03.png";